import { Icon, ScrollArea, Sidebar, SidebarContent, SidebarHeader, Text, useSidebar } from '@mntn/ui-components'
import { useCallback } from 'react'
import { Button } from '@/components/shared'
import { useFilter } from '../context/filter-context'
import { AirDatesFilter } from '../filters/air-dates-filter'
import { CpmRangeFilter } from '../filters/cpm-range-filter'
import { GenreFilter } from '../filters/genre-filter'
import { NetworkFilter } from '../filters/network-filter'
import { OfferingTypeFilter } from '../filters/offering-type-filter'

interface FilterPanelProps {
  children?: React.ReactNode
}

// biome-ignore lint/plugin: RETIRED, do not copy. Convert to a named function export when touching this.
export const FilterPanel: React.FC<FilterPanelProps> = ({ children }) => {
  const { setOpen } = useSidebar()
  const { activeFiltersCount, clearFilters } = useFilter()

  const onDismiss = useCallback(() => {
    setOpen(false)
  }, [setOpen])

  const handleClearAll = useCallback(() => {
    clearFilters()
  }, [clearFilters])

  return (
    <Sidebar
      side="right"
      variant="sidebar"
      collapsible="offcanvas"
      className="border-l border-borders-primary bg-background shadow-lg"
      onDismiss={onDismiss}
    >
      <SidebarHeader className="p-6 border-b border-borders-primary">
        <div className="flex items-center justify-between">
          <Text variant="lg-sb" className="font-bold">
            Filters
          </Text>
          <div className="flex items-center gap-2">
            {activeFiltersCount > 0 && (
              <Button variant="ghost" size="small" onClick={handleClearAll} className="text-xs">
                Clear All ({activeFiltersCount})
              </Button>
            )}
            <Button variant="ghost" size="small" onClick={onDismiss} className="h-6 w-6 p-0">
              <Icon name="X" className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </SidebarHeader>
      <SidebarContent className="bg-gray-g1">
        <ScrollArea className="flex-1">
          <div className="flex flex-col">
            <OfferingTypeFilter />
            <NetworkFilter />
            <GenreFilter />
            <CpmRangeFilter />
            <AirDatesFilter />
            {children}
          </div>
        </ScrollArea>
      </SidebarContent>
    </Sidebar>
  )
}
